import React from "react";
import "./articledetail.scss";
import Globals from "../../api";
import { Suspense, lazy } from "react";
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
//import Article_bottom_text from '../ad-units/article_bottom_text';
import ROS_Left_336_280 from '../ad-units/Ros_left_300_250';
import ROS_Middle_Center_728_90 from '../ad-units/ros_middle_center_728_90';
import Ros_bottom_center_728_90 from '../ad-units/Ros_bottom_center_728_90';
import ROS_Top_Center_728_90 from '../ad-units/Ros_top_center_728_90';
import ReactHtmlParser, { convertNodeToElement } from "react-html-parser";
//import RelatedArticle from "../../components/RelatedArticle/relatedarticle";
import Rightbar from "../../components/Rightbar/Rightbar";
import { Helmet } from "react-helmet";
import ImageConvertionDefault from "../../config";
import { data } from "jquery";


export default class ArticleDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Articledata: [],
      videos: [],
      meta: [],
      title: [],
      meta_keywords: [],
      meta_description: [],
      AdUnits : [],
      Ogimage :[],
      Domainurl : [],
      Horoscope :[],
      Rightbar : [], 
      googleAds : [],
      CricketData : [] , 
      hasAdultContent : [],
      AdultContent :false
    };
  }
  getHoroscope() {
    // console.log('api at header' + Globals.language_based_api);
        const url= Globals.language_based_api+'%2Fhome-page';
        fetch(url)
        .then((res) => res.json())
        .then((data) => {
          
            this.setState({
              Horoscope : data.Contents
            })
        }) 
      }

      getGoogleAds(){
             const url= Globals.AdConfig;
              fetch(url)
                .then((res) => res.json())
                .then((data) => {
                let URI = window.location.pathname;
                const url1 = Globals.language_based_api + URI;
                  fetch(url1)
                .then((res1) => res1.json())
                  .then((data1) => {
                   this.setState({
                    AdultContent : data1.AdultContent
                  });
                  // console.log("adult content ",data1.AdultContent)
                 if(data1.AdultContent){
                    this.setState({
                        googleAds : data.AdContents[0].SLROS
                      })
                    } else{
                this.setState({
                   googleAds : data.AdContents[0].ROS
                })
               }
              });
             }) 
                
     }
  getAds(){
    const url = Globals.Ad_api;
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          AdUnits: data.AdContents[0].header_sponsor_logo,
        });
      });
  }
  getRightbar(){
    let URI = window.location.pathname.split("/");
    const url = Globals.Rightbar_api+ "/" + URI[2];
    //const url = Globals.Rightbar_api;
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          Rightbar: data.Contents[0]
        });
      });
  }

  getCricketUpdate(){
    const url= Globals.Cricket_update_api;
    //const url ="https://m-marathidev.webdunia.com/ad-config/ticker-test.json";
    fetch(url)
    .then((res) => res.json())
    .then((data) => {
        this.setState({
          CricketData : data.CurrentMatches
          
        })
    })   
    //console.log("url ",url)
  }
  
  componentDidMount() {
    let URI = window.location.pathname;
    const url = Globals.language_based_api + URI;
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        let AdultContent = data;
        this.setState({
          Articledata: data.Contents,
          meta: data.Meta,
          title: data.Title,
          meta_keywords: data.Meta.keywords.Attributes.content,
          meta_description: data.Meta.description.Attributes.content,
          Ogimage: data.Contents[2].Thumbnail,
          Domainurl : data.Contents[2].Url , 
          hasAdultContent : data.AdultContent
        });
        if (data.AdultContent) {
        const mgidScript = document.getElementById("en_mgid");
        const aniviewScript = document.getElementById("AV6116617f030a6739bb279bb7");
        const momagic_script = document.getElementById("interactive_js_adcode");
        const andbeyond_script = document.getElementById("andbeyond_script");
        const vuukle_script = document.getElementById("vuukle_script");
        const vuukle_comments = document.getElementById("vuukle-comments");
        const momagic_sc= document.getElementById("momagic_script");
         const mgidWidget = document.querySelector('div[data-type="_mgwidget"][data-widget-id="1630959"]');
          if (mgidWidget) {
            mgidWidget.remove();
          }
          if (momagic_sc) {
            momagic_sc.remove();
          }
           if (aniviewScript) {
            aniviewScript.remove();
          }
         setTimeout(() => {
                const aniviewScript = document.querySelector('script[src="https://player.aniview.com/script/webm/ads.js"]');
                if (aniviewScript) {
                  aniviewScript.remove();
                  } 
                  if (momagic_script) {
                  momagic_script.remove();
                 }
                 const avScript = Array.from(document.querySelectorAll('script')).find(
                  (script) =>
                    script.src &&
                    script.src.includes("player.aniview.com/script/6.1/AVmanager.js")
                 );
                if (avScript) {
                 avScript.remove();
                } 
                if (mgidScript) {
                  mgidScript.remove();
                }
                if (aniviewScript) {
                  aniviewScript.remove();
                }
                if (momagic_script) {
                  momagic_script.remove();
                }
                if (andbeyond_script) {
                  andbeyond_script.remove();
                }
                  if (vuukle_script) {
                  vuukle_script.remove();
                }
                if (vuukle_comments) {
                  vuukle_comments.remove();
                }
                 const vuukleQuiz = document.getElementById("vuukle-quiz-container");
                 if (vuukleQuiz) {
                vuukleQuiz.remove();
                 }
            }, 2000); 
               const aniPlayerDiv = document.getElementById('aniview_player');
                if (aniPlayerDiv) {
                  aniPlayerDiv.remove();
              }
               const interactive_js_adcode = document.getElementById("interactive_js_adcode");
              if (interactive_js_adcode) {
                interactive_js_adcode.remove();
              }
              const vuukleQuiz = document.getElementById("vuukle-quiz-container");
              if (vuukleQuiz) {
                vuukleQuiz.remove();
              }
              const mgidWidget1 = document.querySelector('div[data-type="_mgwidget"][data-widget-id="1630933"]');
              if (mgidWidget1) {
                mgidWidget1.remove();
              }
              const bottom_center_ad = document.getElementById("bottom_center_ad");
             if (bottom_center_ad) {
               bottom_center_ad.remove();
             }
             const ad_in_between_art = document.getElementById("ad_in_between_art");
             if (ad_in_between_art) {
              ad_in_between_art.remove();
             }
              window.addEventListener("scroll", function onScroll() {
              const momagicScript = document.getElementById("interactive_js_adcode");
              if (momagicScript) {
                momagicScript.remove();
              const vuukleQuiz = document.getElementById("vuukle-quiz-container");
                        if (vuukleQuiz) {
                          vuukleQuiz.remove();
                        }
                        if (vuukle_script) {
                    vuukle_script.remove();
                  }
                window.removeEventListener("scroll", onScroll);
              }
            });
          }
      });
      this.getHoroscope();
     // console.log("data.AdultContent",this.state)
      this.getRightbar();
      //if( == false){
        this.getGoogleAds();
        this.getAds();
     // }
      
      this.getCricketUpdate();
  }
  

  
  render() {
    // console.log("hasadult", this.state.hasAdultContent)
   const FilterHtmlContent = (item) => {
      if (item.Type == "Video") {
        return (
          <div>
            {" "}
            {/* <iframe
              className="Youtube-iframe"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              src={item.EmbedUrl}
            ></iframe> */}
            <LiteYouTubeEmbed 
            className="Youtube-iframe"
            id={item.EmbedUrl.split("/").pop()}
            title="youtube embed"
            poster="mqdefault"
            webp = {true}
    />
          </div>
        );
      }
      if (item.Type == "Image") {
        return (
          <>
           <div className="arti_img">
            <img src={ImageConvertionDefault(item.Path)} alt={ (typeof item.alttext != "undefined" ? item.alttext  : "webdunia")} className="imgCont" />
          </div>
            <Suspense fallback={renderLoader()}>   
            {/* <div className="full_ads_block">
              
            <Ros_bottom_center_728_90 AdData = {(this.state.hasAdultContent == false)? this.state.googleAds : ''}/> 
            </div> */}

            <div className="ad_in_between_art" id="ad_in_between_art">
            <ROS_Left_336_280 AdData = {(this.state.hasAdultContent == false)? this.state.googleAds : ''}/> 
            </div>

            </Suspense>
            </>
        );
      }
      if (item.Type == "AdSpace" && item.Index == 1 ) {
        return (
          <>
          {/* <div id="M598980ScriptRootC934514"> </div> */}
          {/* <div className="ad_in_between1"> */}
            {/* <ROS_Left_336_280 AdData = {this.state.googleAds}/> */}
          <Suspense fallback={renderLoader()}>   
          <Helmet>
                  <script src="/js/adgebra_middle.js" data-cfasync="false"></script>
                  </Helmet>
                  <div className="container">
                  <div data-type="_mgwidget" data-widget-id="1630959"> 
 </div> 
                  </div>
           
          </Suspense>
          {/* <div id="aniview_player" style={{ margin: '0 auto ', marginBottom : '20px' , marginTop : '20px' , maxWidth :'450px' , clear : 'both'}}></div> */}
         
          </>
        );
      }

      if (item.Type == "FreeHtml") {
        var Html = item.Html;
         Html = Html.replace('<div style="text-align: justify;"><div>', "<br />");
         Html = Html.replace('<div style="text-align: justify;">&nbsp;</div>', "<br />");
        Html =  Html.replace("<pre>","");
        
        return (
<>
<Helmet>
<script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
<script async src="https://www.instagram.com/embed.js"></script>
</Helmet>

{ReactHtmlParser(Html)}
</>
        );
      }
    }
    //console.log("Rightbar",this.state.googleAds);
    const renderLoader = () => <div className="loading_screen"></div>;
    let Articledata = this.state.Articledata;
    let ArticledataFull = Articledata;
    let PagelistData = ArticledataFull.filter((x) => x.Type === "PageList");
    let relatedNews = PagelistData.slice(1, 2);
    let ArticleContent = ArticledataFull.filter((x) => x.Type === "Article");
    let ArticleContentCC = ArticleContent;
    // const SearchTags = [];
    const ArticledataFullItems = ArticleContentCC.map((item, i) => {
      const propertyName = [item.RelatedArticles];
      return (
        <div key={i}>
          <div className="article_sticky_sect sticky-top">
            <div className="arti_written">
              <span>Written By</span> {item.AuthorName || "N.A."}
            </div>

            <div className="arti_date">
              <span>Last Updated:</span> {item.DateTime}
            </div>
            <div className="arti_social_block">
              <ul>
                <li>
                  <a
                    href={
                      "https://www.facebook.com/share.php?u=" +
                      item.Url +
                      "&utm_source=facebook&utm_medium=social&utm_campaign=fbshare"
                    }
                    title={item.Title}
                    target="_blank"
                    className="art_fb_icon"
                  ></a>
                </li>
                <li>
                  <a
                    href={
                      "https://twitter.com/intent/tweet?status=" +
                      item.Title +
                      "+&url=" +
                      item.Url +
                      "&utm_source=twitter&utm_medium=social&utm_campaign=twshare"
                    }
                    className="art_tw_icon"
                  ></a>
                </li>
                <li>
                  <a
                    href={
                      "https://api.whatsapp.com/send?text=" +
                      item.Title +
                      " / " +
                      item.Url +
                      "&utm_source=whatsapp&utm_medium=social&utm_campaign=washare"
                    }
                    className="art_whapp_icon"
                  ></a>
                </li>
                <li>
                  {/* <a href="" className="art_email_icon"></a> */}
                </li>
              </ul>
            </div>
            {/* { const array = [item.RelatedArticles] ; } */}
            {
                (() => {
                  if (propertyName[0] != null ) {
                   
                  return (
                   propertyName.map((item, i) => (
                <div className="next_article_block" key={i}>
                  <h3>ಮುಂದಿನ ಲೇಖನ</h3>
                  <ul>
                    {item.Items.map((item, i) => (
                      <li key={i}>
                        <a href={item.Url}>{item.Title}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              ))
                 
                  )
                }})()}
          </div>
          <div className="article_content">
            <div className="article_in_content">
              <div className="article_title ">
                <h1>{item.Title}</h1>
              </div>
              {item.Contents.map((item, i) => {
                if (item.Type == "KeywordCloud") {
                  this.SearchTags = item.Pages;
                }
                return (
                  <div key={i}>
                    {FilterHtmlContent(item)}
                  </div>
                );
              })}
              {/* <div style={{font: "18.0pt" , fontFamily:"Tunga sans-serif" }}> 
           <a href="https://www.kannadamatrimony.com/" target="_blank" style={{textDecoration: "none", cursor: "pointer"}}>
          <div style={{color:'blue' , display : 'inline'}}>
          <b>
          ಸೂಕ್ತ ಸಂಗಾತಿ ಬೇಕಾ? ಕನ್ನಡ ಮ್ಯಾಟ್ರಿಮೊನಿಯಲ್ಲಿ - 
          </b></div>
          <div style={{ color:'red' , display : 'inline'}}> <b>ನೋಂದಣಿ ಉಚಿತ!</b></div>
          </a> 
          </div> */}
                    <div id="aniview_player" style={{ margin: '0 auto ', marginBottom : '20px' , marginTop : '20px' , maxWidth :'450px' , clear : 'both'}}></div>

          <br />
            </div>
            <div className="readmore_tags">
              <ul className="readm_tags_list">
                <li>
                  <span>ಇನ್ನಷ್ಟು ಓದಿ :</span>
                </li>
                {this.SearchTags.map((item, i) => (
                  <li key={i}>
                    <a href={item.Url}>{item.Title}</a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
            
            
          {/* <Ros_bottom_center_728_90 AdData = {this.state.googleAds} /> */}
        </div>
            {/* <div> <Article_Middle_728_90 AdsData={this.state.AdUnits}/></div> */}
           
          </div>
        </div>
      );
    });
   //console.log("ddsadnsad",this.state.Domainurl);
    return (
      <>
       <div className="full_ads_block">
                 <Suspense fallback={renderLoader()}>
               <ROS_Top_Center_728_90 AdData = { this.state.googleAds } />
             </Suspense>
             </div>
      <div className="article_detail ">
        <Helmet>
       
        <script async id="AV6116617f030a6739bb279bb7" type="text/javascript" src="https://tg1.aniview.com/api/adserver/spt?AV_TAGID=6116617f030a6739bb279bb7&AV_PUBLISHERID=6072c4c6f50b1d56f001c8ad"></script>
        <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
        <script async src="https://www.instagram.com/embed.js"></script> 
        
        </Helmet>
       
        <div className="container">
          <div className="row ">
            <div className="col">
              <div className="aritcle_container">{ArticledataFullItems}</div>
              
              <div id="ad_video_player"></div>
              <br/>
              
              
              <div className="article_after_seciton" id="bottom_center_ad">
              <div className="full_ads_block">
                 <Suspense fallback={renderLoader()}>
               <ROS_Middle_Center_728_90 AdData = {(this.state.hasAdultContent == false)? this.state.googleAds : ''} />
             </Suspense>
             </div>
             <Helmet>
                  <script src="/js/adgebra.js" data-cfasync="false"></script>
                  </Helmet>
                  
                  <div data-type="_mgwidget" data-widget-id="1630933"> 
                  </div> 
                  

                {/* <RelatedArticle dataFromParent={relatedNews} /> */}
                <br />
                <Helmet>
                <script src= "/js/vuukle.js"  id="vuukle_script" ></script>
                </Helmet>
                <div id='vuukle-comments'></div> 
                {/* <Article_bottom_text  /> */}
             
              </div>
            </div> 
            <div className="col right_side_bar">
           <Rightbar Rightbar = {this.state.Rightbar} googleAds = {this.state.googleAds } CricketData = {this.state.CricketData}
           />
           </div>
          </div>
        </div>
      </div>
      <Helmet>
      <script src= "/js/banner.js"  ></script>
      </Helmet>
      </>
    );
  }
}
